<template>
    <body v-if="isLogin" class="hold-transition sidebar-mini layout-navbar-fixed">
      <div class="wrapper">
        <ThePreLoader></ThePreLoader>
        <TheNavBar></TheNavBar>
        <TheSideBar></TheSideBar>
        <div class="content-wrapper">
          <TheContentHeader></TheContentHeader>
          <section class="content">
            <div class="container-fluid">
              <router-view></router-view>
            </div>
          </section>
        </div>
        <TheFooter></TheFooter>
        <TheControlSideBar></TheControlSideBar>
      </div>

      <TheChangePassword/>
      <TheChangeProfile/>
    </body>
</template>

<script>
// eslint-disable-next-line
import ThePreLoader from "@/components/shared/ThePreloader.vue";
import TheContentHeader from "@/components/shared/TheContentHeader.vue";
import TheNavBar from "@/components/shared/TheNavBar.vue";
import TheSideBar from "@/components/shared/TheSideBar.vue";
import TheFooter from "@/components/shared/TheFooter.vue";
import TheControlSideBar from "@/components/shared/TheControlSidebar.vue";
import TheChangePassword from "@/components/authentication/TheChangePassword.vue";
import TheChangeProfile from "@/components/authentication/TheChangeProfile.vue";

import { mapState, mapActions } from 'vuex'
export default {
  name: "TheAdminLayout",
  data() {
    return {
      isLogin: false,
      submitted: false,
    }
  },
  components: {
    ThePreLoader,
    TheContentHeader,
    TheNavBar,
    TheSideBar,
    TheFooter,
    TheControlSideBar,
    TheChangePassword,
    TheChangeProfile
  },
  computed: {
    ...mapState({
      user: state => state.authentication
    }),
  },
  methods: {
    ...mapActions('header', ['setupHeader',]),
    setup() {
      let header = "Trang chủ"
      this.setupHeader({ header });
    },
  },
  mounted() {
    this.setup();
    let user = JSON.parse(localStorage.getItem("login_info"));
    this.isLogin = user && Date.parse(user.expiresTime) > Date.now() ? true : false;
  }
};
</script>

<style>
</style>
